import axios, {AxiosRequestConfig, AxiosResponse} from 'axios'
import {vue} from '@/main'
import appConfig from '@/data/config'
import VueCompositionApi, {computed, reactive} from "@vue/composition-api"
import Vue from "vue"

Vue.use(VueCompositionApi) // workaround for plub-in composition API, should be removed in Vue 3
export const api = axios.create()

export interface Auth {
  userId: string;
  sessionId: string;
  loggedIn: boolean;
  expiry: Date;
}

export const auth: Auth = reactive({
  userId: "",
  sessionId: "",
  loggedIn: computed(() => (!!auth.sessionId && auth.expiry > new Date())),
  expiry: new Date(),
})

export function loadAuth() {
  if (!auth.sessionId && typeof sessionStorage !== "undefined") {
    const sessionData = sessionStorage.getItem("sessionData") || "{}"
    try {
      const s = JSON.parse(sessionData) as Auth
      auth.sessionId = s.sessionId
      auth.userId = s.userId
      auth.expiry = new Date(s.expiry) || new Date()
      console.log("Loaded auth, userId:", auth.userId)
    } catch {
      console.log("Failed to load auth. Session data:", sessionData)
    }
  }
  document.cookie = "SESSIONID" + "=" + encodeURIComponent(auth.sessionId) + "; expires=" + auth.expiry.toUTCString() + "; path=/api/; SameSite=Strict;"
  return auth
}

function saveSession(a: Auth) {
  sessionStorage.setItem("sessionData", JSON.stringify(a))
}

export function login(a: Auth) {
  const expiry = new Date() // ToDo: replace with real expiry date from auth service
  expiry.setHours(23, 59, 59, 999)
  Object.assign(auth, {sessionId: a.sessionId, userId: a.userId, expiry})
  api.defaults.headers.Authorization = 'Bearer ' + a.sessionId
  saveSession(auth)
  console.log("Logged in as", auth.userId)
}

export function logout() {
  sessionStorage.removeItem("sessionData")
  auth.userId = ""
  auth.sessionId = ""
  auth.expiry = new Date()
  const logoutUrl = appConfig.AUTH_LOGOUT_URL + "?returnUrl=" + appConfig.BASE_URL
  window.location.href = logoutUrl
  // delete api.defaults.headers.Authorization
}

export function getAuthHeader(): string|null {
  // if token in state is null load it from browser session storage
  const sso = loadAuth()
  return sso.sessionId ? 'Bearer ' + sso.sessionId : null
}

api.interceptors.request.use((r: AxiosRequestConfig): AxiosRequestConfig => {
  const ah = getAuthHeader()
  r.baseURL = appConfig.AUTH_API_URL
  if (ah !== null) {
    r.headers.Authorization = ah
  }
  return r
})

api.interceptors.response.use((response: AxiosResponse<any>): AxiosResponse<any> => {
  return response
}, (err) => {
  if (err.response === undefined) {
    console.log('Error response: ', err)
  }
  if (err.response.status === 400 || err.response.status === 401) { // ToDo: remove 400 when server is fixed
    console.log('error code', err.response.status)
    logout()
  } else if (err.response.status > 499 && err.response.status < 600) {
    if (err.response.data !== undefined && err.response.data.errorMessage !== undefined) {
      console.log('auth request failed', err.response.data.errorMessage)
    } else {
      console.log('auth request failed', err.response.statusText)
    }
  }
})

export function ssoRedirect(returnPath: string = vue.$router.currentRoute.fullPath) {
  let authURL = appConfig.AUTH_URL
  authURL = authURL.replace('AUTH_CALLBACK_URL', encodeURIComponent(appConfig.AUTH_CALLBACK_URL))
  authURL = authURL.replace('PAGE_RETURN_URL', encodeURIComponent(returnPath))
  window.location.href = authURL
}
